module.exports = __webpack_public_path__ + "img/ai7@2x.51167e5f.png";